import { Link } from '@micro-frontend-react/employee-experience/lib/Link';
import { Label } from '@fluentui/react/lib/Label';
import * as React from 'react';
import * as WindowSize from '../../Hooks/useWindowDimensions';
import * as styled from './Footer.styled';

export function Footer(): React.ReactElement {
  const year = new Date().getFullYear();
  const { width, height } = WindowSize.useWindowDimensions();

  return (
    <styled.FooterRoot data-testid="footer-panel-root">
      <styled.Container>
        <styled.FooterMenus>
          <styled.FooterMenuItem windowWidth={width} windowHeight={height}>
            <Link
              to="https://go.microsoft.com/fwlink/?LinkId=518021"
              title="Microsoft data privacy notice"
              target="_blank"
              usageEvent={{
                feature: 'Offboarding',
                subFeature: 'Footer.DataPrivacyLink',
              }}
            >
              Microsoft data privacy notice
            </Link>
          </styled.FooterMenuItem>
          <styled.FooterMenuItem
            arie-aria-roledescription={`${year} Microsoft`}
            windowWidth={width}
            windowHeight={height}
            style={{ marginLeft: 'auto' }}
          >
            <Label style={{ fontWeight: 400 }}>&copy; {year} Microsoft</Label>
          </styled.FooterMenuItem>
        </styled.FooterMenus>
      </styled.Container>
    </styled.FooterRoot>
  );
}
